import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { RadioButtonGroup, RadioButton } from 'material-ui/RadioButton';
import { withTranslation } from 'react-i18next';
import { STATUS_SELECTOR } from '../../../shared/utils/constants';

const StatusSelector = ({ input, t, ...rest }) => {
  const color = { color: '#646777' };
  const fill = { fill: '#646777' };

  return (
    <MuiThemeProvider>
      <Fragment>
        <RadioButtonGroup
          {...input}
          {...rest}
          valueSelected={input.value}
          onChange={(event, value) => input.onChange(value)}
          className="radio-button-selector"
        >
          <RadioButton
            iconStyle={fill}
            labelStyle={color}
            value={STATUS_SELECTOR.ACTIVE}
            label={t(`status.${STATUS_SELECTOR.ACTIVE}`)}
          />
          <RadioButton
            iconStyle={fill}
            labelStyle={color}
            value={STATUS_SELECTOR.CANCELED}
            label={t(`status.${STATUS_SELECTOR.CANCELED}`)}
          />
          <RadioButton
            iconStyle={fill}
            labelStyle={color}
            value={STATUS_SELECTOR.FINISHED}
            label={t(`status.${STATUS_SELECTOR.FINISHED}`)}
          />
        </RadioButtonGroup>
      </Fragment>
    </MuiThemeProvider>
  );
};

StatusSelector.propTypes = {
  input: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(StatusSelector);
